import { Observable, distinctUntilChanged } from 'rxjs';

import { finShare, safeMap } from '@fcom/rx';

import { BaseState, PseudoLocalState } from '../interfaces/app-state.interface';

/**
 * Selects the current value from the state via given key.
 */
export const pseudoLocal =
  (key: string) =>
  (state$: Observable<BaseState>): Observable<string | boolean> =>
    state$.pipe(
      safeMap((s: BaseState) => s.pseudoLocal),
      safeMap((s: PseudoLocalState) => s[key] as string | boolean),
      distinctUntilChanged(),
      finShare()
    );
